import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/home.vue'
import dashboard from '../views/dashboard/index.vue'
import Card from '../views/card/index.vue'
import Service from '../views/service/index.vue'
import PrivacyPolicy from '../views/privacyPolicy/index.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: dashboard,
        children: [
            {
                path: '/card',
                name: 'card',
                component: Card,
                meta: {
                    title: '我的卡片',
                },
            },
            {
                path: '/privacyPolicy',
                name: 'privacyPolicy',
                component: PrivacyPolicy,
                meta: {
                    title: '隐私协议',
                },
            },
            {
                path: '/service',
                name: 'service',
                component: Service,
                meta: {
                    title: '常见问题',
                },
            },
        ]
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
